module.exports = {
  language: 'Italiano',
  applierApplicationCenter: {
    selectCenterTip: 'Seleziona questo centro'
  },
  multiplePage: {
    moreInfomation: 'Maggiori informazioni',
    recommendedServices: 'Servizi consigliati'
  },
  checkoutConfirm: {
    ordered: 'Ordinato',
    purchased: 'Acquistato'
  },
  personal: {
    purgePopupContent:
      'Siamo spiacenti, i dati della tua domanda sono stati eliminati a causa della politica di sicurezza, puoi contattarci se desideri candidarti presto'
  },
  login_maximum: {
    errorContent: 'You have reached maximum login times, please retry the next day.'
  },
  nationalityKay: 'it-it',
  noneSelectedText: 'Selezionare',
  multiselect: {
    deselect: 'Premi Enter per rimuovere',
    select: 'Premi Enter per selezionare',
    selected: 'Selezionato'
  },
  enter: ' accedere',
  upload_failed: 'Caricamento non riuscito, riprova',
  due_time: 'Tempo dovuto',
  requirement: 'Requisiti',
  something_went_wrong_please_retry: 'Qualcosa è andato storto, riprovare.',
  valid_rediret_home_page_popup_content:
    'Si è verificata un\'eccezione di accesso. Si sta cercando di accedere alla homepage di [ {country} - {center} ] per effettuare il login? Se sì, cliccare su "Conferma"; se no, cliccare su "Annulla" per selezionare nuovamente.',
  invalid_rediret_home_page_popup_content: "Si è verificata un'eccezione di accesso, selezionare il paese e la località per procedere.",
  'Temporarily not available': 'Temporaneamente non disponibile',
  'Coming soon': 'Prossimamente'
};
